import React from 'react';
import { Components } from 'src/configs/components/components';

export class Constructor {
  public static renderWidgets = (settings: { [key: string]: any }): any => {
    if (!settings || typeof settings !== 'object' || !Object.keys(settings).length) {
      return <></>;
    }

    const orderIndex = {};

    Object.keys(settings).forEach((key: string) => (orderIndex[`${key}`] = settings[key].priority));

    return Object.keys(settings)
      .sort((a: string, b: string) => orderIndex[a] - orderIndex[b])
      .filter((key: string) => key !== 'styles')
      .map((key: string, i: number) => {
        const Component = Components[key];
        if (!Component) {
          return null;
        }

        return React.createElement(Component, {
          settings: settings[key] || {},
          placement: 'sidebar',
          key: `${key}_${i}`,
        });
      });
  };
}
